<template>
    <div class="header-services">
        <div v-for="(item, index) in servicesCatalog" :key="`services_adult_${index}`" class="services-item"
            @click="setChildrenServices(item)">
            <div class="services-item__header">
                <NuxtLink :to="{
                    name: 'home',
                    params: { chapters: useSlugTransform(item.full_slug) },
                }" class="services-item__title">{{ item.title }}
                </NuxtLink>
                <span
                    class="services-item__chevron"
                    :class="{ 'is-open': currentItemId === item.id }"
                >
                    <NuxtIcon name="IconChevronVerticalSmall" />
                </span>
            </div>
            <Transition name="services-mobile-submenu">
                <div
                    v-if="isOpenChild && currentItemId === item.id"
                    class="services-mobile-submenu"
                >
                    <div class="services-mobile-submenu__inner">
                        <div class="services-item__childs">
                            <NuxtLink
                                v-for="(child, cIndex) in item.children"
                                :key="`${index}_${cIndex}`"
                                :to="{
                                    name: 'home',
                                    params: { chapters: useSlugTransform(child.full_slug) },
                                }"
                                @click.stop
                            >
                                {{ child.title }}
                            </NuxtLink>
                        </div>
                    </div>
                </div>
            </Transition>
        </div>
    </div>

</template>

<script setup lang="ts">
import { computed, ref, onMounted, useServicesIconName, useSlugTransform, useState } from '#imports';
import UIButton from '~/components/UI/button/UIButton.vue';
import type { ServicesResults } from '~/types/pages';
import { useWindowSize } from '@vueuse/core';

defineEmits(['onClose']);

const { width } = useWindowSize();

const servicesCatalog = useState<ServicesResults[]>('servicesCatalog');

const childrenServices = ref<ServicesResults[]>([]);
const childrenTitle = ref<string | null>(null);
const currentItemId = ref<null | number>(null);

const isOpenChild = ref(false);

const setChildrenServices = (item: ServicesResults) => {
    if (currentItemId.value === item.id) {
        currentItemId.value = null;
        isOpenChild.value = false;
        return;
    }

    childrenServices.value = item.children;
    childrenTitle.value = item.title;
    currentItemId.value = item.id;

    isOpenChild.value = true;
};

</script>

<style scoped lang="scss">
.header-services {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-left: 8px;

    .services-item {
        color: $color-typography-primary;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;

        &__header {
            display: flex;
            align-items: center;
            align-self: stretch;
            gap: 16px;
            color: $color-typography-invert;

            .services-item__chevron {
                display: inline-flex;
                transition: transform 0.2s ease-in-out;

                &.is-open {
                    transform: rotate(180deg);
                }
            }

        }

        &__title {
            flex: 0 1 auto;
            color: $color-typography-invert;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            text-decoration: none;
        }


        &__childs {
            display: flex;
            flex-direction: column;
            gap: 16px;
            padding: 8px 0;
            padding-left: 8px;
            align-items: flex-start;


            a {
                color: $color-typography-invert;
                display: inline-block;
                font-size: 16px;
                font-weight: 500;
                line-height: 20px;
                text-decoration: none;
                padding: 0;
            }
        }
    }

    .services-child {
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        padding: 16px 0;
        text-decoration: none;
        display: block;
        color: $color-typography-invert;
    }

    .services-mobile-submenu {
        display: grid;
        grid-template-rows: 1fr;
        opacity: 1;
        transition:
            grid-template-rows 0.25s ease,
            opacity 0.2s ease;

        &__inner {
            min-height: 0;
            overflow: hidden;
        }
    }

    .services-mobile-submenu-enter-from,
    .services-mobile-submenu-leave-to {
        grid-template-rows: 0fr;
        opacity: 0;
    }
}
</style>
